export const DELIVERY_TIME_CONFIG = {
    HANDLING_MIN_DAYS: 0,
    HANDLING_MAX_DAYS: 1,
    TRANSIT_MIN_DAYS: 0,
    TRANSIT_MAX_DAYS: 0,
    UNIT_DAY: "d"
};